import * as React from 'react';
import FormView from '../../FormView/index';
import SummaryPanel from '../SummaryPanel/index';
import SummaryTable from 'components/common/SummaryTable';
import * as SummaryTableSchema from '../SummaryTableSchema.json';
import { IReorderingProps, IReorderingState } from '../interfaces';

class Reordering extends React.PureComponent<IReorderingProps, IReorderingState> {

  constructor(props: IReorderingProps) {
    super(props);
    this.state = {
      selectedSettingByWHLine: null,
    };
  }

  componentDidMount(): void {
    const { path, onInitialLoad } = this.props;
    const context = 'inventory-enquiry';
    if (path) {
      switch (path) {
        case `/${context}/reordering/purchase-orders`:
          onInitialLoad('IEPurchaseOrders');
          break;
        case `/${context}/reordering/suppliers`:
          onInitialLoad('IESuppliers');
          break;
        case `/${context}/reordering/settings-by-warehouse`:
          onInitialLoad('IESettingsByWarehouse');
          break;
        default:
          onInitialLoad('IEPurchaseOrders');
      }
    }
  }

  componentDidUpdate(prevProps: IReorderingProps): void {
    const { selectedSettingByWHLine } = this.props;
    if (selectedSettingByWHLine !== prevProps.selectedSettingByWHLine) {
      this.setState({ selectedSettingByWHLine });
    }
  }

  getSummaryTableRenderer = (selectedTab: any) => {
    switch (selectedTab) {
      case 'IESettingsByWarehouse':
        return () => {
          const loading = false;

          return <SummaryTable
            settingsByWHSummary={this.state.selectedSettingByWHLine}
            data={SummaryTableSchema.SettingByWHSummary}
            loadingSummary={loading}
          />;
        };
      default: return null;
    }
  }

  render(): React.ReactNode {
    const { isBrowseLookUpOpen, selectedForm, operationMode, selectedTab } = this.props;

    return (selectedForm &&
      <React.Fragment>
        <SummaryPanel
          variant={'ProductDetails'}
        />
        <FormView
          formName={selectedTab}
          browseLookUpOpen={isBrowseLookUpOpen}
          includeTabsHeight={false}
          schema={selectedForm}
          initialValues={null}
          operationMode={operationMode}
          enableReinitialize={true}
          valuesSchema={null}
          summaryTableRenderer={this.getSummaryTableRenderer(selectedTab)}
        />
      </React.Fragment>
    );
  }
}

export default Reordering;
